import type { RootState } from "single-spa/store/types";

export const selectCurrentDashboardId = (state: RootState) => state.customDashboard.currentDashboard.dashboardId;

export const selectIsDashboardEditing = (state: RootState) => state.customDashboard.dashboardWizard.isEditing;

const selectDashboardWidgetId = (state: RootState) => state.customDashboard.dashboardWizard.widget.id;

export const selectDashboardWizard = (state: RootState) => state.customDashboard.dashboardWizard;
